import { createContext } from 'react';
import type { JsonLdNode } from '@/lib/structuredData';

/** Server render paytida useSeo shu obyektga yozadi — prerender skripti <head> ni quradi. */
export interface HeadTags {
  title?: string;
  description?: string;
  /** Kanonik yo'l ("/problems/foo") */
  path?: string;
  noindex?: boolean;
  /** Sahifadagi barcha schema.org tugunlari (sayt bo'yicha + sahifaga xos) */
  jsonLd?: JsonLdNode[];
}

export const SeoCollectorContext = createContext<HeadTags | null>(null);
